import { Component, Injector, OnInit, ChangeDetectorRef } from '@angular/core';
import { BasicTextInputComponent } from '../../basic-text-input/basic-text-input.component';
import { SubjectManager } from '../../../../../../../common/js/subjectManager/SubjectManager';

@Component({
  moduleId: module.id,
  selector: 'custom-percent-input',
  templateUrl: '../../basic-text-input/basic-text-input.component.html',
})
export class CustomPercentInputComponent extends BasicTextInputComponent implements OnInit {
  constructor(protected injector: Injector, cdRef: ChangeDetectorRef) {
    super(injector);
  }

  ngAfterViewInit() {
    const propertyName = this.handleIterate(this.questionItem.prop).split('.').join('_') + '_changed';
    SubjectManager.publish(propertyName);
  }

  updateFromModel() {
    super.updateFromModel();
    this.cdRef.detectChanges();
  }
}
